import { FormControlLabel, Radio, RadioGroup } from "@mui/material";

import { FormDatePicker } from "components/form/FormDatePicker/FormDatePicker";
import { FormField } from "components/form/FormField/FormField";

import style from "../CervicalCheck.module.css";

const radioSx = {
  "&.Mui-checked": {
    color: "var(--green-900)",
  },
};

export const CervicalScreeningTestInformation = ({ form, today }) => {
  return (
    <>
      <h2
        style={{
          fontSize: "20px",
          lineHeight: "32px",
          marginTop: "24px",
        }}
      >
        Cervical Screening Test Information
      </h2>
      <div className={style.inputGroupGrid}>
        <FormField name="dateOfTest">
          <label className={style.addLetterFormLabel}>Date of Test</label>
          <div className={style.addPregnancyDatePickerWrapper}>
            <FormDatePicker
                form={form}
                name="dateOfTest"
                emptyValue={today}
              />
          </div>
        </FormField>

        <FormField name="sampleSite">
          <label className={style.addLetterFormLabel}>Sample site</label>
          <RadioGroup
            options={[
              { label: "Cervix", value: "cervix" },
              { label: "Vault (post total hysterectomy)", value: "vault" },
            ]}
            defaultValue="cervix"
            {...form.register("sampleSite")}
          >
            <div className={style.radioGroup}>
              <FormControlLabel
                value="yes"
                control={<Radio size="small" sx={radioSx} />}
                label="Yes"
              />
              <FormControlLabel
                value="no"
                control={<Radio size="small" sx={radioSx} />}
                label="No"
              />
            </div>
            <p style={{ marginTop: "4px" }}>
              Where the cervix is present, the sampletaker must visualise the
              entire cervix and sample it correctly with 5 x 360° rotations of
              the broom/brush. Submission of the sample is confirmation that
              this has been done.
            </p>
          </RadioGroup>
        </FormField>
      </div>
    </>
  );
};
